import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNotify, useRefresh } from 'react-admin';
import { useState } from 'react';
import { goApi } from '../../services';

interface DeleteQuestionsButtonProps {
    questionIds: string[];
    onSuccess?: () => void;
}

const DeleteQuestionsButton = ({
    questionIds,
    setSelectedIds,
    onSuccess,
}: DeleteQuestionsButtonProps & { setSelectedIds?: any }) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleConfirmOpen = () => setOpenConfirm(true);
    const handleConfirmClose = () => setOpenConfirm(false);

    const handleDelete = async () => {
        if (!questionIds?.length) return;

        setLoading(true);

        try {
            const result = await goApi.delete<any>('/qb/delete', {
                body: JSON.stringify({ QuestionIds: questionIds }),
            });
            if (result && result?.data) {
                notify('Question(s) deleted successfully', { type: 'success' });
                setSelectedIds?.([]);
                onSuccess?.();
                setTimeout(() => refresh(), 100);
            } else {
                notify(result?.message || 'Failed to delete question(s)', { type: 'error' });
            }
        } catch (error) {
            notify('Bad request during deletion', { type: 'error' });
        } finally {
            setLoading(false);
            handleConfirmClose();
        }
    };

    return (
        <>
            <Button
                startIcon={<DeleteIcon />}
                onClick={handleConfirmOpen}
                disabled={loading || !questionIds.length}
                color="error"
            ></Button>

            <Dialog open={openConfirm} onClose={handleConfirmClose}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete {questionIds.length} question
                        {questionIds.length > 1 ? 's' : ''}?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="error" disabled={loading}>
                        {loading ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteQuestionsButton;
